import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export async function fetchConstituencies() {
  const { data } = await api.get("/constituencies");
  return data.items || [];
}

export async function fetchCandidates(constituency) {
  const { data } = await api.get("/candidates", { params: { constituency } });
  return data;
}

export async function fetchAlliances() {
  const { data } = await api.get("/alliances");
  return data;
}
